import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableActions from "./table-actions";
import { NoData } from "src/shared/components/tables/no-data";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { useTranslation } from "react-i18next";
import { Box, Button, Stack, TablePagination, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import AddEditClientPopup from "./add-edit-client";
import { oneBranchHasPermission } from "src/utils";
import FilterDrawer from "./filters";
import { InventoryPermissions } from "src/constants/permissions";
import { useGetClientsList } from "src/api/sales/clients";

const ClientsTable = () => {
  const { t } = useTranslation("purchasing");
  const { t: salesT } = useTranslation("addSales");
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);
  const [open, setOpen] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [name, setName] = useState("");
  const [sku, setSku] = useState("");
  const [type, setType] = useState("all");

  const HeadText = [
    t("name"),
    t("email"),
    t("accountBank"),
    t("balance"),
    salesT("contactNum"),
    t("createdBy"),
    t("createdAt"),
    t("actions"),
  ];

  // APIS
  const { data, isFetching, refetch } = useGetClientsList({
    page: pageNumber + 1,
  });

  // permissions
  const addProPermission = oneBranchHasPermission(InventoryPermissions.addPro);
  const editProPermission = oneBranchHasPermission(
    InventoryPermissions.editPro,
  );
  const addProEntryPermission = oneBranchHasPermission(
    InventoryPermissions.createProEntry,
  );

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = (type: any) => {
    setOpen(true);
  };

  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const emptyDataArr = data?.data.length === 0;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPageNumber(newPage);
  };

  useEffect(() => {
    setPageNumber(0); // when filters change return to first page
    refetch();
  }, [name, sku, type]);

  useEffect(() => {
    if (data) {
      setTotal(data.meta?.total as number);
    }
  }, [data]);

  return (
    <Stack spacing={3} maxWidth={{ xs: "100%", md: `calc(100vw - 316px)` }}>
      <Box display={"flex"} justifyContent={"flex-end"}>
        <Stack
          direction={"row"}
          gap={2}
          flexWrap={"wrap"}
          mt={{ xs: 2, md: 5, lg: 0 }}
        >
          {/* <Button
            color="tertiary"
            variant="outlined"
            endIcon={<img src={FilterIcon} height={"16px"} alt="" />}
            onClick={handleOpenFilter}
          >
            {t("filter")}
          </Button> */}

          {true && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleOpen}
              size="small"
            >
              {salesT("addClient")}
            </Button>
          )}
        </Stack>
      </Box>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {HeadText.map((item) => (
                <TableCell
                  key={item}
                  align={"center"}
                  sx={{
                    bgcolor: "#F9FAFB",
                  }}
                >
                  <Typography
                    fontSize={"12px"}
                    color={"#475467"}
                    lineHeight={"18px"}
                    fontWeight={500}
                  >
                    {item}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {isFetching || !data ? (
            <TableLoadingSkeleton rowsLength={15} cellsLength={8} />
          ) : (
            <TableBody>
              {data.data.map((row: any) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{row.name}</TableCell>
                  <TableCell align="center">{row.email}</TableCell>
                  <TableCell align="center">{row.bank_account}</TableCell>
                  <TableCell align="center">{row.balance}</TableCell>
                  <TableCell align="center">{row.phone}</TableCell>
                  <TableCell align="center">{row.created_by?.name}</TableCell>
                  <TableCell align="center">{row.created_at}</TableCell>
                  <TableCell align="right">
                    <TableActions row={row} refetch={refetch} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
        {emptyDataArr && <NoData />}
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20]}
        component="div"
        count={total}
        rowsPerPage={20}
        page={pageNumber}
        onPageChange={handleChangePage}
        showFirstButton
        showLastButton
      />

      {/* {open && ( */}
        <AddEditClientPopup
          open={open}
          handleClose={handleClose}
          refetch={refetch}
        />
      {/* )} */}

      <FilterDrawer
        open={openFilter}
        name={name}
        setName={setName}
        sku={sku}
        setSku={setSku}
        type={type}
        setType={setType}
        handleClose={handleCloseFilter}
      />
    </Stack>
  );
};
export default ClientsTable;
